import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 评分争议 — 由管理员终审, 仅允许编辑 final_score / admin_remark.
 */
export const scoringDisputesConfig: CrudConfig = {
  resource: 'scoring-disputes',
  title: '评分争议处理',
  rowKey: 'id',
  searchFields: ['status'],
  disableCreate: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true, hideInForm: true },
    { name: 'answer_sheet_uuid', label: '答卷 UUID', type: 'text', copyable: true, width: 260, readonly: true, ellipsis: true },
    { name: 'score_min', label: '最低分', type: 'number', width: 100, readonly: true },
    { name: 'score_max', label: '最高分', type: 'number', width: 100, readonly: true },
    { name: 'score_diff', label: '分差', type: 'number', width: 100, readonly: true },
    { name: 'threshold', label: '阈值', type: 'number', width: 100, readonly: true, hideInTable: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 120,
      options: [
        { label: '待处理', value: 'PENDING', status: 'Warning', color: 'orange' },
        { label: '处理中', value: 'REVIEWING', status: 'Processing', color: 'blue' },
        { label: '已终审', value: 'RESOLVED', status: 'Success', color: 'green' },
      ],
    },
    { name: 'final_score', label: '终审得分', type: 'number', width: 110, tooltip: '管理员判定的最终分数' },
    { name: 'admin_remark', label: '管理员备注', type: 'textarea', hideInTable: true },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true },
  ],
};
